import { render, staticRenderFns } from "./ManufacturerDistributor.vue?vue&type=template&id=0d418ea0&"
import script from "./ManufacturerDistributor.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports